// moms-harness:anchor v2
// JIRA: LOGISPRD-14571
import React from 'react'
import { Input, type PboTableColumn } from '@musinsa/pbo-core'

/** 바코드 열의 dataIndex. 행 타입·검증이 이 키를 쓴다 */
export const BARCODE_DATA_INDEX = 'barcode'

/**
 * 바코드 열에만 행별 셀을 끼운다 — **신규 행만 입력칸, 조회된 기존 행은 읽기 전용 텍스트**다 (LOGISPRD-14571).
 *
 * ### 왜 기존 행은 읽기 전용인가
 *
 * 화주 + 바코드가 곧 SKU 다. 바코드를 바꾸는 것은 SKU 를 새로 만드는 일이라 SCM Hub 채번 키를 건드리고,
 * 수정 API 는 바코드를 아예 받지 않는다. 초판은 모든 행을 `variant: 'input'` 으로 그리고 편집을 `onCellChange`
 * 에서 막아, 기존 행 바코드 칸에 **한 글자 칠 때마다 「바코드는 변경할 수 없습니다」 경고가 쌓였다.** 입력칸을
 * 주고 막는 대신 처음부터 입력칸을 주지 않는다.
 *
 * pbo-core 는 컬럼에 `render` 가 있으면 variant 렌더러보다 우선한다 — 단가 열의 [withPriceCells] 와 같은
 * 탈출구다. 그래서 `consts.ts` 의 바코드 열은 **variant 를 두지 않는다** — 남겨 두면 이 함수 없이 `COLUMNS` 를
 * 쓰는 순간 기존 행 입력칸이 되살아난다.
 */
export const withBarcodeCell = (columns: PboTableColumn[], onChange: (rowKey: string, dataIndex: string, text: string) => void): PboTableColumn[] =>
  columns.map((column) => {
    if (column.dataIndex !== BARCODE_DATA_INDEX) return column
    return {
      ...column,
      render: (value, row) => {
        const text = typeof value === 'string' ? value : ''
        if (row._isNew !== true) return <span data-testid="barcode-readonly">{text}</span>
        // `row` 는 `Record<string, unknown>` 이라 행 키가 보장되지 않는다 — 없으면 편집을 넘기지 않는다 (PriceCell 과 같은 기준)
        const rowKey = row._rowKey
        return (
          // 필수 열이다 — variant 를 쓰지 않으면 pbo-core 의 필수 빈칸 표시(placeholder「입력」)가 빠지므로 셀이 직접 준다
          <Input
            value={text}
            placeholder="입력"
            status={text.trim() ? undefined : 'error'}
            // antd 는 status 만으로 aria-invalid 를 달지 않는다 — 보조기기에도 필수 빈칸임을 알린다
            aria-invalid={text.trim() ? undefined : true}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              if (typeof rowKey === 'string' && rowKey) onChange(rowKey, BARCODE_DATA_INDEX, e.target.value)
            }}
          />
        )
      },
    }
  })
